
export default function Gallery() {
  const images = [
    {
      url: 'https://static.readdy.ai/image/6736d1852cbe3c6486d637a41ef2edca/ba5b504f70ff1db99d9257f99a0065ae.jpeg',
      alt: 'Massage Therapy Room',
      tall: true,
    },
    {
      url: 'https://static.readdy.ai/image/6736d1852cbe3c6486d637a41ef2edca/a78daee7e28f3b18bfe825f2fc3fb55e.jpeg',
      alt: 'Therapeutic Massage Technique',
      tall: false,
    },
    {
      url: 'https://static.readdy.ai/image/6736d1852cbe3c6486d637a41ef2edca/13287449b4724cf77bee0d7cf893e5b0.jpeg',
      alt: 'Hot Stone Therapy Setup',
      tall: false,
    },
    {
      url: 'https://public.readdy.ai/ai/img_res/9340ca1b246d6fc25e61ab29bf03eaae.jpg',
      alt: 'Spa Interior',
      tall: true,
    },
    {
      url: 'https://static.readdy.ai/image/6736d1852cbe3c6486d637a41ef2edca/a2d96d69947a90e9e521bd7c656b65f9.jpeg',
      alt: 'Aromatherapy Oils',
      tall: false,
    },
    {
      url: 'https://static.readdy.ai/image/6736d1852cbe3c6486d637a41ef2edca/fd2a55520f7d7facb05ef47f0c4ad19b.jpeg',
      alt: 'Massage Session',
      tall: true,
    },
  ];

  return (
    <section id="gallery" className="py-32 px-8 lg:px-16 bg-[#F5F3F0]">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl lg:text-5xl font-light text-center text-[#2C2C2C] mb-20" style={{ fontFamily: 'Georgia, serif' }}>
          Our Space
        </h2>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className={`mb-6 break-inside-avoid ${image.tall ? 'h-[500px]' : 'h-[300px]'}`}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover object-top rounded-lg hover:opacity-90 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
